import axios from "axios";

const HTTPClient = axios.create({
    withCredentials: true,
    baseURL:
        !process.env.NODE_ENV || process.env.NODE_ENV === "development"
            ? "http://localhost:8042/api/v1"
            : "https://api.appbox.cloud/api/v1",
});

HTTPClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error?.response?.status === 401 && window.location.pathname !== "/login") {
            localStorage.removeItem("user");
            window.location.href = "/login";
        }
        return Promise.reject(error);
    }
);

export default HTTPClient;
